import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminProtectedRoute from './components/auth/AdminProtectedRoute';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CustomerEarnings from './pages/CustomerEarnings';
import CustomerDetails from './pages/CustomerDetails';
import AdminSettings from './pages/AdminSettings';
import AdminLayout from './components/shared/AdminLayout';

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Public admin routes */}
      <Route path="/login" element={<AdminLogin />} />
      
      {/* Protected admin routes */}
      <Route element={<AdminProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="customers" element={<CustomerEarnings />} />
          <Route path="customers/:customerId" element={<CustomerDetails />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Route>
      
      {/* Catch all - redirect to login */}
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
};

export default AdminRoutes;